import { useEffect, type ReactNode } from 'react'
import { Center, Loader } from '@mantine/core'
import { Navigate, useLocation } from 'react-router-dom'
import { fetchMe } from '../../shared/api/auth'
import { useAuthStore } from './store'

/**
 * AuthGate — определяет статус сессии при первом рендере. Если access-токен
 * пуст (in-memory только), пытается /auth/refresh через cookie. Если получилось,
 * грузит /me и пускает дальше. Иначе → /login.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { user, status, setUser, setStatus } = useAuthStore()
  const location = useLocation()

  useEffect(() => {
    if (status !== 'idle') return
    setStatus('loading')
    fetchMe()
      .then(setUser)
      .catch(() => setUser(null))
  }, [status, setUser, setStatus])

  if (status === 'idle' || status === 'loading') {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // После админского сброса: пока пароль не сменён, API отвечает 403 на всё, кроме /me
  // и /me/password — держим пользователя на экране смены.
  if (user.must_change_password && location.pathname !== '/me/password') {
    return <Navigate to="/me/password" replace />
  }

  return <>{children}</>
}
